export const visibleButton = ({ visible }) => visible
